import * as React from 'react'

const HomeIcon = (props) => {
  const { color } = props
  return (
    <svg
      width={49}
      height={49}
      viewBox='0 0 49 48'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      {...props}
    >
      <defs>
        <path id='home-icon_svg__a' d='M0 0h38.272v40.586H0z' />
      </defs>
      <g fill='none' fillRule='evenodd'>
        <path
          d='M24.136 24.271a2.096 2.096 0 0 1-2.093-2.094c0-1.153.94-2.092 2.093-2.092 1.155 0 2.094.939 2.094 2.092a2.096 2.096 0 0 1-2.094 2.094m0-6.226a4.138 4.138 0 0 0-4.134 4.132 4.138 4.138 0 0 0 4.134 4.134 4.138 4.138 0 0 0 4.134-4.134 4.138 4.138 0 0 0-4.134-4.132'
          fill={color}
        />
        <g transform='translate(5 4.5)'>
          <mask id='home-icon_svg__b' fill='#fff'>
            <use xlinkHref='#home-icon_svg__a' />
          </mask>
          <path
            d='M25.567 38.545V27.511c0-.562-.457-1.02-1.021-1.02H13.725a1.02 1.02 0 0 0-1.02 1.02v11.034H5.937V18.774L19.135 5.575l13.2 13.199v19.771h-6.768zm-10.822 0h8.781V28.533h-8.781v10.012zm22.851-21.042L20.769.676a2.31 2.31 0 0 0-3.265 0L.674 17.503A2.304 2.304 0 0 0 3.897 20.8v18.766a1.02 1.02 0 0 0 1.018 1.022h28.439c.564 0 1.022-.458 1.022-1.022V20.8a2.3 2.3 0 0 0 1.588.645 2.31 2.31 0 0 0 1.632-3.942z'
            fill={color}
            mask='url(#home-icon_svg__b)'
          />
        </g>
      </g>
    </svg>
  )
}

export default HomeIcon
